import { ChevronDownSpriteIcon } from '@bridebook/web/app-basic/components/search/search-svg-sprite';
import { memo } from 'react';
import ReactPaginate from 'react-paginate';

interface IProps {
  items: number;
  activePage: number;
  onSelect: (item: { selected: number }) => void;
  hrefBuilder?: (index: number) => string;
  maxButtons?: number;
}

const linkClass =
  'flex justify-center items-center w-10 h-10 text-base leading-5 text-space rounded-full hover:bg-space-08 hover:no-underline focus:no-underline active:no-underline';

const Pagination = ({
  items,
  activePage,
  onSelect,
  hrefBuilder,
  maxButtons: maxButtonsProp,
}: IProps) => {
  const maxButtons = maxButtonsProp || 4;

  return (
    <div
      className="flex items-center justify-center [&_.pagination]:flex [&_.pagination]:list-none [&_.pagination]:items-center [&_.pagination]:select-none [&_.pagination_li]:ml-[5px] [&_.pagination_li.break]:pointer-events-none [&_.pagination_li.break]:cursor-default [&_.pagination_li.disabled]:pointer-events-none [&_.pagination_li.disabled]:cursor-default [&_.pagination_li.selected]:pointer-events-none [&_.pagination_li.selected]:cursor-default [&_.pagination_li.selected_a]:bg-space [&_.pagination_li.selected_a]:text-white [&_.pagination_li:first-of-type]:ml-0 [&_.pagination_li:last-of-type]:mr-0 [&_.pagination_li:nth-of-type(2)]:ml-0"
      data-name="pagination">
      <ReactPaginate
        containerClassName="pagination"
        previousLabel={
          <ChevronDownSpriteIcon
            width={16}
            height={16}
            className={`rotate-90 ${activePage === 0 ? 'text-space-40' : 'text-space'}`}
          />
        }
        nextLabel={
          <ChevronDownSpriteIcon
            width={16}
            height={16}
            className={`-rotate-90 ${items === activePage + 1 ? 'text-space-40' : 'text-space'}`}
          />
        }
        pageLinkClassName={linkClass}
        previousLinkClassName={linkClass}
        nextLinkClassName={linkClass}
        breakLinkClassName={linkClass}
        hrefBuilder={hrefBuilder}
        pageCount={items}
        pageRangeDisplayed={maxButtons}
        marginPagesDisplayed={1}
        forcePage={activePage}
        onPageChange={onSelect}
        selectedPageRel={null}
      />
    </div>
  );
};

export default memo(Pagination);
